import { t } from '@/i18n';
import { z } from 'zod';

export const expenseDetailSchema = z.object({
  title: z
    .string()
    .min(1, t('pages.fundraising_campaign.components.fundraising_campaign_justify_expenses_modal.schema.requireded')),
  value: z.number().min(0.1, t('pages.fundraising_campaign.components.fundraising_campaign_justify_expenses_modal.schema.requireded')),
  receipt: z.any().refine(item => {
    return !!item;
  }, t('pages.fundraising_campaign.components.fundraising_campaign_justify_expenses_modal.schema.requireded')),
  is_editing: z.boolean().default(false),
});

export const modalFormSchema = z
  .object({
    thank_you_message: z.string().optional(),
    total_expenses: z.number().default(0).optional(),
    expenses_details: z.array(expenseDetailSchema).optional(),
  })
  .superRefine((values, ctx) => {
    if (!values.thank_you_message) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['thank_you_message'],
        message: t('pages.fundraising_campaign.components.fundraising_campaign_justify_expenses_modal.schema.required'),
      });
    }

    if ((values.total_expenses || 0) < 0.1) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['total_in_expenses'],
        message: t('pages.fundraising_campaign.components.fundraising_campaign_justify_expenses_modal.schema.required'),
      });
    }

    values?.expenses_details?.forEach((detail, index) => {
      if (!detail?.title) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['expenses_details', index, 'title'],
          message: t('pages.fundraising_campaign.components.fundraising_campaign_justify_expenses_modal.schema.requireded'),
        });
      }

      if (!detail?.value) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['expenses_details', index, 'value'],
          message: t('pages.fundraising_campaign.components.fundraising_campaign_justify_expenses_modal.schema.requireded'),
        });
      }

      if (!detail?.receipt) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['expenses_details', index, 'receipt'],
          message: t('pages.fundraising_campaign.components.fundraising_campaign_justify_expenses_modal.schema.requireded'),
        });
      }
    });
  });

export type ModalFormData = z.infer<typeof modalFormSchema>;
